import { 
  Phone, MapPin, Check, 
  Leaf, Droplets, Shovel, Ruler,  Trees, 
  ShieldCheck, 
} from 'lucide-react';
import { Link } from 'react-router-dom';

  const slugify = (text) => {
    return text
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/[^\w ]+/g, '') // Entfernt Sonderzeichen außer Leerzeichen
      .replace(/ +/g, '-');    // Ersetzt Leerzeichen durch -
  };


const ServicesPage = () => {

  // ================= DATA CONFIGURATION =================
  const servicesList = [
    {
      id: 1,
      title: "Baumfällen",
      icon: <Trees size={32} />,
      desc: "Fachgerechtes Fällen von Bäumen jeder Größe unter sicheren Bedingungen.",
      features: ["Gefahrenbaum-Entfernung", "Schnitt- & Falltechnik", "Zertifizierte Sicherheit", "Baumstumpf-Beseitigung"]
    },
    {
      id: 2,
      title: "Gartenpflege",
      icon: <Leaf size={32} />,
      desc: "Regelmäßige Pflege für einen gesunden und schönen Garten.",
      features: ["Rasenmähen & Düngen", "Unkrautbekämpfung", "Beetpflege", "Heckenpflege"]
    },
    {
      id: 3,
      title: "Heckenschneiden",
      icon: <Ruler size={32} />,
      desc: "Formschönes Schneiden und Pflegen von Hecken und Sträuchern.",
      features: ["Formschnitt", "Sichtschutz-Hecken", "Strauchpflege", "Schnittgut-Entsorgung"]
    },
    {
      id: 4,
      title: "Holzterrassen",
      icon: <Shovel size={32} />,
      desc: "Planung und Aufbau von langlebigen Holzterrassen nach Maß.",
      features: ["Terrassenbau & Montage", "Holzauswahl & Behandlung", "Pflege & Versiegelung", "Reparaturen & Austausch"]
    },
    {
      id: 5,
      title: "Pflastersteine",
      icon: <Droplets size={32} />,
      desc: "Verlegung von Pflastersteinen für Wege, Einfahrten und Terrassen.",
      features: ["Wege & Einfahrten", "Terrassen & Plätze", "Drainage-Lösungen", "Individuelle Muster"]
    },
    {
      id: 6,
      title: "Zaunbau",
      icon: <ShieldCheck size={32} />,
      desc: "Professioneller Bau von Zäunen für Sicherheit und Privatsphäre.",
      features: ["Holz- & Metallzäune", "Torinstallation", "Sichtschutz & Sicherheit", "Wartung & Reparatur"]
    }
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-slate-800">

      {/* ================= 1. NAVBAR (Reusable) ================= */}


      {/* ================= 2. PAGE HEADER ================= */}
      <header className="relative w-full h-[400px] flex items-center justify-center bg-slate-900">
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?q=80&w=2664&auto=format&fit=crop" 
            alt="Services Header" 
            className="w-full h-full object-cover opacity-50"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent"></div>
        </div>
        <div className="relative z-10 text-center px-4 max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Unsere Dienstleistungen</h1>
          <p className="text-lg text-slate-200 leading-relaxed">
            Von Baumfällen bis Zaunbau – wir bieten alle Services, die Ihr Grundstück benötigt. <br/>
            Professionell, zuverlässig und individuell auf Ihre Bedürfnisse abgestimmt.
          </p>
        </div>
      </header>

      {/* ================= 3. DETAILED SERVICES GRID ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-emerald-700 font-bold uppercase tracking-wide text-sm mb-2">Unsere Leistungen</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900">Alles aus einer Hand</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {servicesList.map((service) => (
              <div key={service.id} className="border border-slate-100 rounded-xl p-8 shadow-sm hover:shadow-xl hover:border-emerald-500 transition-all duration-300 group">
                <div className="flex items-center gap-4 mb-6">
                  <div className="p-3 bg-emerald-50 rounded-lg text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-colors">
                    {service.icon}
                  </div>
                  <h4 className="text-xl font-bold text-slate-900">{service.title}</h4>
                </div>
                <p className="text-slate-600 mb-6 min-h-[50px]">{service.desc}</p>
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-slate-700 text-sm">
                      <Check size={16} className="text-emerald-500 shrink-0 mt-0.5" strokeWidth={3} />
                      {feature}
                    </li>
                  ))}
                </ul>
                 <div className="mt-auto">
    <Link 
    to={`/services/${slugify(service.title)}`} 
    className="inline-block mt-4 text-emerald-700 font-bold hover:text-emerald-900 transition-colors"
  >
    See More →
  </Link>
      </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= 4. MAINTENANCE PACKAGES ================= */}


      {/* ================= 5. PROCESS SECTION ================= */}
     <section className="py-24 bg-emerald-50">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-12">
      <h3 className="text-3xl font-bold text-emerald-800">So Arbeiten Wir</h3>
      <p className="text-emerald-700 text-lg max-w-2xl mx-auto mt-2">
        Von der ersten Idee bis zum fertigen Garten – wir begleiten Sie Schritt für Schritt.
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
      {/* Left: Steps */}
      <div className="space-y-6">
        {[
          { title: "Beratung", desc: "Wir besuchen Ihr Grundstück, hören Ihre Wünsche und beraten Sie individuell.", icon: <MapPin size={24} className="text-emerald-600" /> },
          { title: "Planung & Angebot", desc: "Detaillierte Pläne und ein transparentes Angebot für absolute Klarheit.", icon: <Ruler size={24} className="text-emerald-600" /> },
          { title: "Umsetzung", desc: "Unser Team arbeitet sauber, effizient und mit Liebe zum Detail.", icon: <Shovel size={24} className="text-emerald-600" /> },
          { title: "Abnahme & Zufriedenheit", desc: "Wir überprüfen gemeinsam das Ergebnis, bis alles perfekt ist.", icon: <Check size={24} className="text-emerald-600" /> }
        ].map((step, idx) => (
          <div key={idx} className="flex gap-4 bg-white p-5 rounded-2xl shadow-md hover:shadow-lg transition-shadow">
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full text-emerald-600">
              {step.icon}
            </div>
            <div>
              <h4 className="text-xl font-semibold text-emerald-800">{step.title}</h4>
              <p className="text-emerald-700 mt-1">{step.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Right: Cozy Image */}
      <div className="relative h-full min-h-[400px] rounded-2xl overflow-hidden shadow-lg">
        <img
src="https://plus.unsplash.com/premium_photo-1668930508685-af79c83e23af?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"          alt="Cozy Process"
          className="w-full h-full object-cover filter brightness-90 hover:scale-105 transition-transform duration-500 rounded-2xl"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-800/40 to-transparent rounded-2xl"></div>
      </div>
    </div>
  </div>
</section>

      {/* ================= 6. CTA / FOOTER START ================= */}
      <div className="bg-emerald-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6">Individuelle Lösungen gewünscht?</h2>
            <p className="text-emerald-100 mb-8 max-w-2xl mx-auto">
                Wir übernehmen Gewerbeprojekte, HOA-Verwaltungen und großflächige Gartenplanungen. Kontaktieren Sie uns für ein maßgeschneidertes Angebot.
            </p>
            <div className="flex justify-center gap-6">
                <button className="bg-white text-emerald-900 px-8 py-3 rounded-lg font-bold hover:bg-emerald-50 transition-colors">
                    Kontakt aufnehmen
                </button>
                <button className="flex items-center gap-2 font-bold hover:text-emerald-300 transition-colors">
                   <Phone size={20} /> +49 15735547097
                </button>
            </div>
        </div>
      </div>
      
    </div>
  );
};

export default ServicesPage;
